$(document).ready(function () {
  $(".first_dropdown").hide();
  $(".second_dropdown").hide();
  $(".third_dropdown").hide();
  $(".firstofsecond_dropdown").hide();
});
$("#maindd").on("change", function () {
  let val = this.value;
  if (val == "Website related") {
    $(".second_dropdown").hide();
    $(".third_dropdown").hide();
    $(".firstofsecond_dropdown").hide();
    $(".first_dropdown").show();
    $("#order_id").hide();
  } else if (val == "Order related") {
    $(".first_dropdown").hide();
    $(".third_dropdown").hide();
    $(".firstofsecond_dropdown").hide();
    $(".second_dropdown").show();
    $("#order_id").show();
  } else if (val == "Payment/Refund") {
    $(".second_dropdown").hide();
    $(".third_dropdown").hide();
    $(".firstofsecond_dropdown").hide();
    $(".first_dropdown").hide();
    $(".third_dropdown").show();
    $("#order_id").show();
  } else {
    $(".second_dropdown").hide();
    $(".third_dropdown").hide();
    $(".firstofsecond_dropdown").hide();
  }
  //     if(val != null){
  //       $(".issue_cross_icon").show();
  //       }
});
$("#subdd").on("change", function () {
  let val = this.value;
  if (val == "Refund Not Received") {
    $(".firstofsecond_dropdown").show();
  } else {
    $(".firstofsecond_dropdown").hide();
  }
});
// validation
$(document).ready(function () {
  //   $('#sub-btn').click(function(){
  //   $(document).on('change','.original-selector',function(){
  //     var issue= $(this).find('option:selected').attr('value');
  //     if(issue ==''){
  //      $('#error-issue').html('Required');
  //     }
  //   });

  //   });
  $("#contact_name").blur(function () {
    if ($("#contact_name").val().length < 1) {
      $("#error-name").html("Name Required");
    } else {
      $("#error-name").html("");
    }
  });
  $("#contact_name").keyup(function () {
    if ($("#contact_name").val().length < 1) {
      $("#error-name").html("Name Required");
    } else {
      $("#error-name").html("");
    }
  });
  $("#contact_email").blur(function () {
    if ($("#contact_email").val().length < 1) {
      $("#error-email").html("Email Required");
    } else {
      $("#error-email").html("");
    }
  });
  $("#contact_email").keyup(function () {
    if ($("#contact_email").val().length < 1) {
      $("#error-email").html("Email Required");
    } else {
      $("#error-email").html("");
    }
  });
  $("#contact_order_id").blur(function () {
    if ($("#contact_order_id").val().length < 1) {
      $("#error-order-id").html("Order Id Required");
    } else {
      $("#error-order-id").html("");
    }
  });
  $("#contact_order_id").keyup(function () {
    if ($("#contact_order_id").val().length < 1) {
      $("#error-order-id").html("Order Id Required");
    } else {
      $("#error-order-id").html("");
    }
  });
  $("#contact_phone").blur(function () {
    if ($("#contact_phone").val().length < 1) {
      $("#error-no").html("Phone Number Required");
    } else {
      $("#error-no").html("");
    }
  });

  $("#contact_phone").keyup(function () {
    if ($("#contact_phone").val().length < 1) {
      $("#error-no").html("Phone Number Required");
    } else if (
      $("#contact_phone").val().length > 0 &&
      $("#contact_contact_number").val().length != 10
    ) {
      $("#error-no").html("Enter 10 digit mobile number");
    } else {
      $("#error-no").html("");
    }
  });
  $("#maindd").on("change", function () {
    let val = this.value;
    if (val == "Website related") {
      $("#error-order-id").html("");
    } else {
      $("#contact_order_id").blur(function () {
        if ($("#contact_order_id").val().length < 1) {
          $("#error-order-id").html("Order Id Required");
        } else {
          $("#error-order-id").html("");
        }
      });
      $("#contact_order_id").keyup(function () {
        if ($("#contact_order_id").val().length < 1) {
          $("#error-order-id").html("Order Id Required");
        } else {
          $("#error-order-id").html("");
        }
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const contactFormButton = document.querySelector(".contact-form-button");
  const contactForm = document.querySelector("#contact_form");

  if (!contactFormButton || !contactForm) return;

  contactFormButton.addEventListener("click", function (event) {
    event.preventDefault();

    // Form field elements
    const inputName = contactForm.querySelector('[name="contact[name]"]');
    const inputEmail = contactForm.querySelector('[name="contact[email]"]');
    const inputPhone = contactForm.querySelector('[name="contact[phone]"]');
    const inputOrderID = contactForm.querySelector('[name="contact[order_id]"]');
    const inputConsent = contactForm.querySelector("#consent");

    // Error display elements
    const nameError = document.querySelector("#error-name");
    const emailError = document.querySelector("#error-email");
    const phoneError = document.querySelector("#error-no");
    const orderIdError = document.querySelector("#error-order-id");

    // Validation values
    const nameVal = inputName.value.trim();
    const emailVal = inputEmail.value.trim();
    const phoneVal = inputPhone.value.trim();
    const orderIdVal = inputOrderID?.value.trim();
    const isConsentChecked = inputConsent?.checked;

    const email_regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phone_regex = /^[6789]\d{9}$/;

    let isValid = true;

    // Validate name
    if (nameVal === "") {
      nameError.innerHTML = "Name Required";
      isValid = false;
    } else {
      nameError.innerHTML = "";
    }

    // Validate email
    if (emailVal === "") {
      emailError.innerHTML = "Email Required";
      isValid = false;
    } else if (!email_regex.test(emailVal)) {
      emailError.innerHTML = "Enter a valid email address";
      isValid = false;
    } else {
      emailError.innerHTML = "";
    }

    // Validate phone
    if (phoneVal === "") {
      phoneError.innerHTML = "Phone Number Required";
      isValid = false;
    } else if (!phone_regex.test(phoneVal)) {
      phoneError.innerHTML = "Enter 10 digit mobile number";
      isValid = false;
    } else {
      phoneError.innerHTML = "";
    }

    // Validate Order ID conditionally (if visible or applicable)
    const mainVal = document.querySelector("#maindd")?.value;
    if (mainVal !== "Website related" && inputOrderID) {
      if (orderIdVal === "") {
        orderIdError.innerHTML = "Order Id Required";
        isValid = false;
      } else {
        orderIdError.innerHTML = "";
      }
    } else {
      orderIdError.innerHTML = "";
    }

    // Validate consent
    if (!isConsentChecked) {
      isValid = false;
    }

    // If not valid, stop submission
    if (!isValid) return;

    // Proceed to API if all fields are valid
    const header_value = {
      isoLanguage: "EN",
      isoCountry: "IN",
      brandCode: "BH0992",
      campaignId: "PN002385",
      campaignDescription: "Always On",
      origin: "https://www.simpleskincare.in/",
      formType: "signUp",
      entity: "PRM2.6",
    };

    const x_api_key = "b2930cbc-ae89-41f5-ad6a-32491386660d";

    const consumerIdentity = {
      firstName: nameVal,
    };

    const contactDetail = {
      email: emailVal,
      phone: `+91${phoneVal}`,
    };

    const optInStatus = {
      legalAgeConsent: isConsentChecked,
      unileverEmailConsent: isConsentChecked,
      unileverSMSConsent: isConsentChecked,
    };

    const data_value = JSON.stringify({
      profile: {
        header: header_value,
        consumerIdentity,
        contactDetail,
        optInStatus,
      },
    });

    fetch("https://forms-sg.unileversolutions.com/v3", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": x_api_key,
      },
      body: data_value,
    })
      .then((response) => {
        if (response.ok) {
          contactForm.submit();
        } else {
          contactForm.submit(); // fallback
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        contactForm.submit(); // fallback
      });
  });
});
